import React from 'react';
import { translate } from 'react-i18next';

import Utils from 'utils/Utils.js';
import {colors, fontSizes, fonts, spacings, layout} from 'style';
import LoadInline from '../loading/LoadInline.js';
import InvitationItem from './InvitationItem.js';
import './invitations.css';

const style = {
    content: {
        height: '100%',
        position:'relative',
        ...fonts.body,
        lineHeight: '1.5',
    },
    scrollerContainer:{
        paddingTop:'28px',
    },
    group:{
        padding: spacings.base,
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        backgroundColor: 'white',
    },
    notice: {
        height: '28px',
        lineHeight: '28px',
        textAlign: 'center',
        backgroundColor: colors.themeDarkerGrey,
        color: '#fff',
        position: 'absolute',
        top: '0',
        left:'0',
        width: '100%',
    },
    end: {
        paddingTop: '10px',
        textAlign: 'center',
        color: colors.themeBlue,
        fontSize: '1.2em',
        fontWeight: 'bold',
    }
};

const Invitations = ({t, employees, invitationPoints, onClickInvite, busy, endReached, onScroll, setScrollContainer}) => (
    <div style={style.content}>
        {invitationPoints>0 && 
            <div style={style.notice}>{t('invitation_notice_{{points}}', {points:invitationPoints})}</div>
        }
        <div className="full-height" style={style.scrollerContainer}>
            <div className="full-height scrollable" onScroll={onScroll} ref={(el)=>(setScrollContainer(el))}>
                <div style={style.group}>
                    {employees.map((employee)=>(
                        <InvitationItem key={employee.id} 
                                        employee={employee} 
                                        onClickInvite={onClickInvite} />
                    ))}
                </div>
                {busy && 
                    <LoadInline centered /> 
                }
            </div>
        </div>
    </div>
);

export default translate('invitations')(Invitations);





// WEBPACK FOOTER //
// ./src/modules/invitations/Invitations.js